import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../../shared/services/auth.service';

@Component({
	selector: 'app-header-web',
	standalone: true,
	imports: [CommonModule],
	template: `
		<header class="web-header">
			<div class="logo-wrapper ms-4">
				@if (clientLogo()) {
					<img [src]="clientLogo()" alt="Logo Cliente" />
				} @else {
					<img src="assets/images/Logo-KeFirma.png" alt="KeFirma" />
				}
			</div>
		</header>
	`,
	styles: [],
})
export class HeaderWebComponent {
	authService = inject(AuthService);

	clientLogo = computed(() => this.authService.currentUser?.cliente?.logo || '');
}
